import { authClient } from "library/auth";
import { useProfile, UserContext } from "library/hooks/auth";
import { UserProfile } from "library/hooks/types";
import { getAccessToken } from "library/sessionStorageHelper";
import { validateTnCString } from "library/validator";
import { Fragment, useContext, useEffect } from "react";
import { useSiteData } from "react-event-tracker";
import { useMutation } from "react-query";
import { Route, useLocation, useNavigate } from "react-router-dom";
import { LandingWrapper } from "../LandingWrapper/LandingWrapper";

export const PublicRoute = ({
  path,
  component: Component,
  hasLandingWrapper = false,
}) => {
  const { setSiteData, getSiteData } = useSiteData();
  const { isLoggedIn } = useProfile();
  const location = useLocation();

  const Wrapper = hasLandingWrapper ? LandingWrapper : Fragment;

  const { setProfile } = useContext(UserContext);
  const navigate = useNavigate();

  const handleRedirectMutation = useMutation<void, Error>(async () => {
    const userInfo = await authClient.parseTokensAndGetProfile();
    const profile: UserProfile = {
      id: userInfo.id ?? userInfo.email,
      name: userInfo.name ?? "",
      email: userInfo.email ?? "",
    };
    const siteData = getSiteData();

    setProfile(profile);
    setSiteData({
      ...siteData,
      user: {
        authenticationStatus: profile ? "logged in" : "not logged in",
        profile: {
          emailAddress: userInfo.email ?? "",
          profileId: userInfo.id ?? userInfo.email ?? "",
          customerMasterId: getAccessToken() ?? "",
        },
      },
    });

    // start the navigation logic
    switch (path) {
      case "/login":
      case "/register":
        navigate(validateTnCString(profile.id) ? "/" : "/terms");
        break;
      case "/forgot-password":
        navigate("/forgot-password", {
          state: { currentStep: 3 },
        });
        break;
    }
  });

  useEffect(() => {
    if (authClient.isLoginRedirect()) {
      handleRedirectMutation.mutate();
    }
  }, [handleRedirectMutation]);

  if (handleRedirectMutation.isLoading) {
    return null;
  }

  return (
    <Route
      path={path}
      element={
        <Wrapper>
          <Component path={path} location={location} isLoggedIn={isLoggedIn} />
        </Wrapper>
      }
    />
  );
};
